import { Button, Flex, Icon, Space, Spinner, Text } from '@tonic-one/react';
import { DownloadIcon } from '@tonic-one/react-icons';
import { Parser } from '@json2csv/plainjs';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { DashboardApi } from '@Apis';

const DownloadBlockList = () => {
  const { i18n } = useTranslation();
  const [loading, setLoading] = useState<boolean>(false);
  const t_blockListColumn = i18n.getFixedT(
    null,
    null,
    'dashboard.virtualAnalyzer.downloadCCBlockListFile.column'
  );
  const t_blockListRiskLevel = i18n.getFixedT(
    null,
    null,
    'dashboard.virtualAnalyzer.downloadCCBlockListFile.riskLevel'
  );
  const t_blockListDetectType = i18n.getFixedT(
    null,
    null,
    'dashboard.virtualAnalyzer.downloadCCBlockListFile.detectedType'
  );

  const RiskLevel = [3, 2, 1, 0, -1, -7, -8, -11, -12, -102];
  const DetectionTypes = [0, 1, 2, 3];
  function parseData(response: any[]) {
    return response.map((item: any) => {
      return {
        [t_blockListColumn('lastDetected')]: item[0],
        [t_blockListColumn('expiration')]: item[1],
        [t_blockListColumn('riskLevel')]:
          RiskLevel.indexOf(parseInt(item[2], 10)) > -1
            ? t_blockListRiskLevel(`${item[2]}`)
            : t_blockListRiskLevel(`default`),
        [t_blockListColumn('type')]:
          DetectionTypes.indexOf(parseInt(item[3], 10)) > -1
            ? t_blockListDetectType(`${item[3]}`)
            : t_blockListDetectType(`default`),
        [t_blockListColumn('object')]: item[4],
        [t_blockListColumn('fileSHA1')]: item[5],
      };
    });
  }

  function exportCSVFile(data: any) {
    const csv = new Parser().parse(data);
    const url = window.URL.createObjectURL(
      new Blob(['\uFEFF' + csv], { type: 'text/csv;charset=utf-8;' })
    );
    const link = document.createElement('a');
    link.href = url;
    link.download = 'block_list.csv';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  const downloadBlockList = async () => {
    setLoading(true);
    let response = [];
    try {
      response = (await DashboardApi.downloadCCBlockList()).data;
      const csvData = parseData(response);
      exportCSVFile(csvData);
      setLoading(false);
    } catch (error) {
      window.showNotification({
        severity: 'error',
        titleMsg: t('errors.dashboard.blockList.unableToDownloadBlockList'),
      });
      console.error(error);
    } finally {
      setLoading(false);
    }
  };
  const { t } = useTranslation();
  return (
    <Flex align="center">
      <Button
        variant="secondary"
        onClick={downloadBlockList}
        disabled={loading ? true : false}
        _disabled={{
          cursor: 'not-allowed',
        }}
      >
        {loading ? <Spinner size="xs" /> : <Icon as={DownloadIcon} />}
        <Space width="3x" />
        <Text size="sm">
          {t('dashboard.virtualAnalyzer.downloadCCBlockList').replace(
            'amp;',
            ''
          )}
        </Text>
      </Button>
    </Flex>
  );
};
export default DownloadBlockList;
